import React, { useEffect } from 'react'
import { Pane, Button, Pill, ShoppingCartIcon } from 'evergreen-ui'
import { getPreviousDay, getNextDay } from '../util'
import { connect } from 'react-redux'
import { updateCartData } from '../external/actions'
import { withRouter } from 'react-router-dom'

const Navigation = props => {
  const { date, dateChange, cart, clearCart } = props

  useEffect(() => {
    // updateCartData(clearCart)
    if (cart&&cart.isBulkBooking) {
      updateCartData(clearCart())
    }
  }, [])

  return (
    <div className={'navigation-container'}>
      <Pane
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-between'}
        height={60}
        background={'tint2'}
        paddingLeft={20}
        paddingRight={20}
      >
        <div className={'navigation-item navigation-item-left'}>
          <Button
            className={'nav-button'}
            color={'black'}
            appearance={'minimal'}
            flexDirection={'column'}
            alignItems={'flex-start'}
            paddingLeft={0}
            paddingRight={0}
            height={20}
            iconBefore={'arrow-left'}
            onClick={() => dateChange(getPreviousDay(date))}
          >
            Previous Day
          </Button>
        </div>

        {!!(cart && cart.slots && cart.slots.length) && (
          <div className={'cart-and-counter-container'}> 
            <ShoppingCartIcon 
              className='cart'
              color='white' 
              borderRadius={50}
              size={40}
              padding={10}
              onClick={() => {
                props.history.push({
                  pathname: "/checkout",
                  state: { isBulkBooking: false, bulkBookingData: {}}
                })
              }}
            />
            <Pill
              className={'counter'}
              color={'neutral'}
              paddingLeft={4}
              paddingRight={4}
            >
              {cart.slots.length}
            </Pill>
          </div>
        )}
        <div className={'navigation-item navigation-item-right'}>
          <Button
            className={'nav-button'}
            appearance={'minimal'}
            flexDirection={'column'}
            alignItems={'flex-end'}
            paddingLeft={0}
            paddingRight={0}
            height={20}
            iconBefore={'arrow-right'}
            onClick={() => dateChange(getNextDay(date))}
          >
            Next Day
          </Button>
        </div>
      </Pane>
    </div>
  )
}

const mapStateToProps = ({ cart }) => ({
  cart
})

export default withRouter(connect(mapStateToProps)(Navigation))
